import { cn } from '@/lib/utils'
import type { InputHTMLAttributes, SelectHTMLAttributes } from 'react'

export function Input({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={cn(
        'w-full rounded-[8px] border border-[rgba(154,184,194,0.18)] bg-[#090e12]',
        'px-3.5 py-2.5 text-sm text-[#f0f4f8] placeholder:text-[#93a5ad]',
        'transition-colors duration-150',
        'focus:border-[rgba(64,219,241,0.45)] focus:outline-none focus:ring-2 focus:ring-[rgba(64,219,241,0.15)]',
        className,
      )}
      {...props}
    />
  )
}

export function Select({ className, children, ...props }: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select
      className={cn(
        'rounded-[8px] border border-[rgba(154,184,194,0.18)] bg-[#090e12]',
        'px-3 py-2 text-sm text-[#f0f4f8]',
        'focus:border-[rgba(64,219,241,0.45)] focus:outline-none',
        className,
      )}
      {...props}
    >
      {children}
    </select>
  )
}
